import axios from 'axios';

class DxionNonAuth {
  async getUserInfoAsync() {
    return null;
  }

  async refreshTokenAsync() {
    return null;
  }

  async setUserAsync() {
    return null;
  }

  getCurrentUser() {
    return 'local';
  }

  client(baseURL, props) {
    try {
      const client = axios.create({
        ...props,
        baseURL: baseURL,
      });
      return client;
    } catch (error) {
      console.log('api client error => ' + error);
      return null;
    }
  }
}

export default DxionNonAuth;
